// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { h } from '@stencil/core';
import { WidgetStyle } from '../../addi-product-widget/addi-product-widget.d';
import { BannerConfig } from '../../addi-product-banner/addi-product-banner.d';
import { AddiLogoSrc, BadgeSrc } from '../../../assets/icons/images-sources';

const renderBadge = (
  customBannerStyle: WidgetStyle,
  allySlug: string,
  showSkeleton: boolean
): HTMLElement => (
  <div class="addi-banner-bagde addi-banner-custom-bagde">
    {renderBadgeIcon(customBannerStyle, allySlug, showSkeleton)}
  </div>
);

const renderBadgeIcon = (
  customBannerStyle: WidgetStyle,
  allySlug: string,
  showSkeleton: boolean
): HTMLElement => {
  const skeletonClass = showSkeleton ? 'loading' : '';
  const iconClass = 'addi-banner-bagde__icon';
  const baseStyle = BadgeSrc(allySlug, customBannerStyle?.iconType);
  const customStyles = customBannerStyle?.iconSize
    ? {
        ...baseStyle,
        width: customBannerStyle.iconSize,
        height: customBannerStyle.iconSize,
        display: 'block',
      }
    : {
        ...baseStyle,
      };

  return (
    <div class={`${iconClass} ${skeletonClass}`} style={customStyles}></div>
  );
};

const renderInfo = (
  config: BannerConfig,
  showSkeleton: boolean
): HTMLElement => {
  const message = showSkeleton ? '' : generateMessage(config);
  return (
    <div class="addi-banner-info addi-banner-custom-info">
      <div class={`addi-banner-info__message ${showSkeleton ? 'loading' : ''}`}>
        {message}
      </div>
    </div>
  );
};

const generateMessage = ({
  preapproval,
  allySlug,
}: BannerConfig): Record<string, unknown> => {
  const linkLabel = preapproval ? 'Obter pré-aprovado' : 'Saiba mais';

  return (
    <div>
      <strong class="addi-banner-info__message--strong">
        Pix à vista ou parcelado
      </strong>{' '}
      em parcelas que cabem no seu bolso, com{' '}
      <img class="addi-banner-info__addi-logo" src={AddiLogoSrc(allySlug)} />
      .&nbsp;
      <button
        id="show-more-btn_${config.id}"
        class="addi-banner-button addi-banner-button--link"
      >
        {' '}
        {linkLabel}
      </button>
    </div>
  );
};

const buildBanner = (config: BannerConfig): HTMLElement => {
  const showSkeleton = !config.id;
  const badgeComponent = renderBadge(
    config.customBannerStyle,
    config.allySlug,
    showSkeleton
  );
  const infoComponent = renderInfo(config, showSkeleton);

  return (
    <div class="addi-banner-wrapper">
      <div
        id={`addi-banner_${config.id}`}
        class={`addi-banner addi-banner-custom ${
          config?.proposal?.discount && 'addi-banner--with-discount'
        }`}
      >
        {badgeComponent}
        {infoComponent}
      </div>
    </div>
  );
};

export const BNPLBNPNWidgetBR = (config: BannerConfig): HTMLElement => {
  const bannerComponent = buildBanner(config);

  return (
    <div>
      {config?.proposal?.discount ? (
        <div class="addi-banner-discount addi-banner-custom-discount">
          {config.proposal.discount * 100}% de desconto extra
        </div>
      ) : (
        ''
      )}
      {bannerComponent}
    </div>
  );
};
